export const sortByOptions = [
	{
		id: "sortOption-1",
		name: "Latest first",
		key: "modified",
		direction: false,
	},
	{
		id: "sortOption-2",
		name: "Oldest first",
		key: "modified",
		direction: true,
	},
];

export const statusOptions = [
	{
		key: "NEW_DATA_RECEIVED",
		label: "New data received",
	},
	{
		key: "REQUESTED",
		label: "Request For More Information",
	},
	{
		key: "READY_TO_SEND",
		label: "Ready to send",
	},
	{
		key: "SENT",
		label: "Sent",
	},
	{
		key: "DELIVERED",
		label: "Delivered",
	},
	{
		key: "DELIVERY_FAILED",
		label: "Delivery failed",
	},
	{
		key: "PACKAGE_REQUESTED",
		label: "Package requested",
	},
	{
		key: "PACKAGE_ACCEPTED",
		label: "Package accepted",
	},
	{
		key: "PACKAGE_DECLINED",
		label: "Package declined",
	},
	{
		key: "IN_PROCESS",
		label: "In process",
	},
];

export const DATA_TABLE_PARENT = {
	RECEIVED_DATA: "received-data",
	SHARED_DATA: "shared-data"
}
